var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBrokerLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 807,
    height: 807,
    viewBox: "0 0 807 807",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2091_23)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 807,
    height: 807,
    rx: 157.617,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2091_23)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M310.546 404.022C310.546 349.305 348.673 303.501 399.791 291.767C408.158 289.831 416.873 288.807 425.826 288.807H597.279C611.595 288.807 621.556 288.807 628.807 287.16C633.381 286.094 636.867 284.36 639.69 281.534C647 274.219 647 262.446 647 238.901V188.95C647 165.404 647 153.63 639.69 146.315C632.381 139 620.616 139 597.086 139H425.631C405.216 139 385.336 141.312 366.246 145.689C248.676 172.738 161 278.112 161 403.978C160.998 550.346 279.566 669 425.826 669H597.334C611.505 669 621.404 669 628.633 667.394C633.293 666.333 636.832 664.59 639.69 661.73C647 654.415 647 642.641 647 619.094V569.144C647 545.597 647 533.823 639.69 526.508C632.381 519.193 620.616 519.193 597.086 519.193H425.631C362.072 519.193 310.546 467.629 310.546 404.022Z",
    fill: "#383ECB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.903 292.254L399.904 292.254C408.234 290.327 416.911 289.307 425.826 289.307H597.279H597.359C611.605 289.307 621.612 289.307 628.918 287.647L628.92 287.647C633.561 286.566 637.139 284.795 640.044 281.888C643.807 278.122 645.661 273.227 646.582 266.371C647.5 259.537 647.5 250.68 647.5 238.942V238.901V188.95V188.91C647.5 177.171 647.5 168.313 646.582 161.479C645.661 154.623 643.807 149.727 640.044 145.962C636.281 142.196 631.389 140.341 624.538 139.419C617.708 138.5 608.858 138.5 597.127 138.5H597.086H425.631C405.178 138.5 385.261 140.816 366.134 145.201L366.134 145.201C248.342 172.302 160.5 277.874 160.5 403.978C160.498 550.622 279.29 669.5 425.826 669.5H597.334H597.41C611.515 669.5 621.458 669.5 628.742 667.882L628.744 667.882C633.471 666.805 637.103 665.027 640.044 662.083C643.807 658.317 645.661 653.422 646.582 646.566C647.5 639.731 647.5 630.874 647.5 619.135V619.094V569.144V569.103C647.5 557.364 647.5 548.507 646.582 541.673C645.661 534.816 643.807 529.921 640.044 526.155C636.281 522.389 631.389 520.534 624.538 519.612C617.708 518.693 608.858 518.693 597.127 518.693H597.086H425.631C362.348 518.693 311.046 467.354 311.046 404.022C311.046 349.543 349.007 303.937 399.903 292.254Z",
    stroke: "#F6F6F6"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2091_23)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M310.546 403.737C310.546 349.02 348.673 303.216 399.791 291.481C408.158 289.546 416.873 288.521 425.826 288.521H597.279C611.595 288.521 621.556 288.521 628.807 286.875C633.381 285.809 636.867 284.075 639.69 281.249C647 273.934 647 262.161 647 238.616V188.665C647 165.118 647 153.345 639.69 146.03C632.381 138.715 620.616 138.715 597.086 138.715H425.631C405.216 138.715 385.336 141.027 366.246 145.404C248.676 172.453 161 277.827 161 403.692C160.998 550.061 279.566 668.715 425.826 668.715H597.334C611.505 668.715 621.404 668.715 628.633 667.109C633.293 666.048 636.832 664.305 639.69 661.445C647 654.13 647 642.356 647 618.809V568.859C647 545.312 647 533.538 639.69 526.223C632.381 518.908 620.616 518.908 597.086 518.908H425.631C362.072 518.908 310.546 467.344 310.546 403.737Z",
    fill: "url(#paint0_linear_2091_23)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_2091_23)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M310.546 404.022C310.546 349.305 348.673 303.501 399.791 291.767C408.158 289.831 416.873 288.807 425.826 288.807H597.279C611.595 288.807 621.556 288.807 628.807 287.16C633.381 286.094 636.867 284.36 639.69 281.534C647 274.219 647 262.446 647 238.901V188.95C647 165.404 647 153.63 639.69 146.315C632.381 139 620.616 139 597.086 139H425.631C405.216 139 385.336 141.312 366.246 145.689C248.676 172.738 161 278.112 161 403.978C160.998 550.346 279.566 669 425.826 669H597.334C611.505 669 621.404 669 628.633 667.394C633.293 666.333 636.832 664.59 639.69 661.73C647 654.415 647 642.641 647 619.094V569.144C647 545.597 647 533.823 639.69 526.508C632.381 519.193 620.616 519.193 597.086 519.193H425.631C362.072 519.193 310.546 467.629 310.546 404.022Z",
    fill: "#7A7FF8"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2091_23",
    x: -60,
    y: -42,
    width: 868,
    height: 912,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -30,
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0429377 0 0 0 0 0.053387 0 0 0 0 0.225228 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2091_23"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2091_23",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2091_23",
    x1: 612.385,
    y1: 633.509,
    x2: 380.754,
    y2: 139.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#383ECB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#383ECB",
    stopOpacity: 0.75
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2091_23"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 807,
    height: 807,
    rx: 157.617,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2091_23"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 161,
    y: 404,
    width: 486,
    height: 265,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_2091_23"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 486,
    height: 265,
    fill: "white",
    transform: "translate(161 139)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBrokerLogo);
export default __webpack_public_path__ + "static/media/icon-broker-logo.1f5dfb1402be97b363e8effc0a92b40d.svg";
export { ForwardRef as ReactComponent };